import React from 'react'

import { Dialog } from 'primereact/dialog'

import BillingAddressCards from '../../../../common/BillingAddressCards'


const ViewGSTINBillAddrs = (props) => {

    const {
        visibleGSTINBillAddrs,
        selectedGSTINBillAddrs,
    } = props


    return (
        <div>
            <Dialog visible={visibleGSTINBillAddrs} onHide={()=>props.handleCloseGSTINBillAddrs()} header="Billing Address" style={{ width: '55vw' }}>
                {
                    selectedGSTINBillAddrs.length === 0 ?
                        <p className='mb-2 mt-0 ml-2 font-semibold billing-address-msg text-700 text-red-500'>Billing addressses are not available</p>
                        :
                        <BillingAddressCards billingAddresses={selectedGSTINBillAddrs} readOnly showLedgerName />                
                }
            </Dialog>
        </div>
    )
}

export default ViewGSTINBillAddrs